module.exports = {
      id: "pdf-usage",
      viewBox: "0 0 21.946 21.946",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#pdf",
      toString: function () {
        return this.url;
      }
    }